import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

export type IncidentStatus = 'open' | 'in_progress' | 'done' | 'wont_do';
export interface IncidentAssignee { id: string; name: string; email: string; }
export interface Incident {
  id: number; environment: string; service: string; logGroupName: string; severity: string;
  status: IncidentStatus; title: string; ruleName: string; firstSeenAt: string; lastSeenAt: string;
  emailCount: number; lastEmailedAt: string; occurrenceCount: number; ownerUserId: string | null;
  ownerName: string | null; ownerAvailable: boolean; jiraIssueKey: string | null; jiraUrl: string | null;
  resolutionNote: string | null; triageVersion: number; triageUpdatedAt: string | null;
  newActivity: boolean; sampleEvents?: unknown[];
  actions: { claim: boolean; release: boolean; takeover: boolean; close: boolean; reopen: boolean };
}
export interface IncidentList {
  environment: string; items: Incident[]; total: number; page: number; pageSize: number; loadedAt: string;
  owners: Array<{ id: string; name: string }>; services: string[];
}
export interface IncidentFilters {
  page: number; pageSize: number; status: string; owner: string; severity: string; service: string; search: string;
}
@Injectable({ providedIn: 'root' })
export class IncidentsService {
  constructor(private readonly restangular: ApiClient) {}
  private root(): any { return this.restangular.one('v5').one('admin').one('log-monitor'); }
  list(filters: IncidentFilters): Promise<IncidentList> {
    return this.root().one('incidents').get(filters).toPromise();
  }
  assignees(): Promise<{ items: IncidentAssignee[] }> { return this.root().one('assignees').get().toPromise(); }
  get(id: string): Promise<Incident> { return this.root().one('incidents', id).get().toPromise(); }
  mutate(incident: Incident, action: 'claim' | 'release' | 'takeover' | 'triage' | 'assign', changes: object = {}): Promise<Incident> {
    const resource = this.root().one('incidents', String(incident.id));
    const body = { triageVersion: incident.triageVersion, ...changes };
    return (action === 'triage' ? resource.customPATCH(body, 'triage') : resource.customPOST(body, action)).toPromise();
  }
}
